import Globals from '@/config/Globals';
//
export default class APIMemberClassifications {
  constructor(API) {
    this.api = API;
  }

  async getAll() {
    const req = await this.api.newBaseRequest('GET');
    req.path = Globals.APIPath_MemberClassifications;
    return await req.exec();
  }

  async create(memberClassificationObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = Globals.APIPath_MemberClassification + Globals.URL_NewIndentifier;
    req.body = { ...memberClassificationObj };
    return await req.exec();
  }

  async update(memberClassificationObj) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = Globals.APIPath_MemberClassification + memberClassificationObj.id;
    delete memberClassificationObj.id;
    req.body = { ...memberClassificationObj };
    return await req.exec();
  }

  async remove(memberClassificationID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = Globals.APIPath_MemberClassification + memberClassificationID;
    return await req.exec();
  }
}
